(() => {
  if (window.__productCollapsible2607Initialized) return;
  window.__productCollapsible2607Initialized = true;

  const COLLAPSIBLE_SELECTOR = '.product-collapsible-2607';
  const ITEM_SELECTOR = '.product-collapsible-2607__item';
  const TRACKING_EVENT_NAME = 'Collapsible-2607-click';

  const normalizeText = (value) => (value || '').replace(/\s+/g, ' ').trim();

  const getTrackingLink = (trigger) => {
    const rawHref = trigger.getAttribute('href') || '';

    if (!rawHref || rawHref.startsWith('javascript:')) return '';

    if (rawHref.startsWith('#')) {
      return rawHref.replace(/^#/, '');
    }

    return trigger.href || rawHref;
  };

  const pushClickTracking = (trigger) => {
    const accordion = trigger.closest(COLLAPSIBLE_SELECTOR);
    if (!accordion) return;

    const title = normalizeText(
      accordion.querySelector('summary .heading')?.textContent ||
        accordion.querySelector('summary')?.textContent,
    );
    const buttonName = normalizeText(trigger.textContent);
    const link = getTrackingLink(trigger);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: TRACKING_EVENT_NAME,
      event_parameters: {
        current_page: window.location.href,
        title,
        button_name: buttonName,
        link,
      },
    });
  };

  document.body.addEventListener('click', function (event) {
    const trigger = event.target.closest(`${COLLAPSIBLE_SELECTOR} [data-link-popup] a`);
    if (!trigger) return;

    pushClickTracking(trigger);

    const popupId = trigger.hash.replace(/^#/, '');
    if (!popupId) return;

    const popup = document.querySelector('.subscribe-popup-' + popupId);
    const popupGroup = document.querySelector('#PopupModal-' + popupId);

    if (popupGroup) {
      event.preventDefault();
      return popupGroup.show();
    }

    if (popup) {
      event.preventDefault();
      popup.classList.remove('hidden');
      popup.classList.add('flex');
      document.body.classList.add('no-scroll');
    }
  });

  const setAccordionOpen = (accordion) => {
    if (!accordion) return;

    if (!accordion.open) {
      accordion.open = true;
    }

    accordion.setAttribute('open', '');
    accordion.setAttribute('aria-expanded', 'true');
  };

  const keepAccordionOpen = (accordion) => {
    setAccordionOpen(accordion);
    requestAnimationFrame(() => setAccordionOpen(accordion));
    setTimeout(() => setAccordionOpen(accordion), 80);
  };

  const getItemAccordion = (target) => {
    const item = target?.closest?.(ITEM_SELECTOR);
    return item?.closest?.(COLLAPSIBLE_SELECTOR) || null;
  };

  const initThemeEditorGuard = () => {
    if (!window.Shopify?.designMode) return;

    const itemSelectionAccordions = new WeakSet();

    const rememberItemSelection = (accordion) => {
      if (!accordion) return;

      itemSelectionAccordions.add(accordion);
      keepAccordionOpen(accordion);
      setTimeout(() => itemSelectionAccordions.delete(accordion), 600);
    };

    document.addEventListener(
      'pointerdown',
      (event) => rememberItemSelection(getItemAccordion(event.target)),
      true,
    );

    document.addEventListener(
      'shopify:block:select',
      (event) => {
        const accordion = getItemAccordion(event.target);
        if (!accordion) return;

        event.stopPropagation();
        rememberItemSelection(accordion);
      },
      true,
    );

    document.addEventListener(
      'shopify:block:deselect',
      (event) => {
        const itemAccordion = getItemAccordion(event.target);
        const accordion = itemAccordion ||
          (event.target?.matches?.(COLLAPSIBLE_SELECTOR) && itemSelectionAccordions.has(event.target)
            ? event.target
            : null);

        if (!accordion) return;

        event.stopPropagation();
        keepAccordionOpen(accordion);
      },
      true,
    );
  };

  initThemeEditorGuard();
})();
